<template>
    <div class="basic_wrap">
        <div class="gift-list">
            <div class="one-gf" v-for="(item,k) in good_list" :key="k">
                <img :src="item.img" alt="">
                <b style="color:gold">{{ k2(item.reward_multiple * bet_money) }}</b>
            </div>
        </div>
        <div class="bingo-wrap">
            <div class="rotate-wrap">
                <div class="rotate">
                    <img class="dish" src="../images/04.png" :style="{ transform: rotate_deg, transition: rotate_transition }" />
                    <!-- 指针图片 -->
                    <img class="pointer" src="../images/02.png" @click="go()" />
                </div>
            </div>
            <!-- 转盘包裹 -->

            <div class="tips">
                <div v-show="result_money" class="hoho"> 
                    <img class="ani-img" :src="good_list[result_id].img" alt="">
                    {{$t("共赢得") }} 
                    <b class="res-money">R${{ result_money }}</b>
                </div>
            </div>

            <div class="money-3">
                <div class="mo1">
                    <img class="yue" src="../images/active/coin.png" alt="">
                    <span>R${{ k2(balance) }}</span>
                </div>
                <div class="mo1">
                    <img class="yue" src="../images/active/coin.png" alt="">
                    <span>R${{ k2(bet_money) }}</span>
                </div>
                <div class="mo1">
                    <img class="yue" src="../images/active/coin.png" alt="">
                    <span>R${{ k2(win_money) }}</span>
                </div>
            </div>

            <div class="play-btns">
                <div class="jian" @click="jian()"></div>
                <div class="go" @click="go()"></div>
                <div class="jia" @click="jia()"></div>
            </div>

        </div>

        <audio style="display:none;" src="../../assets/music/start.mp3" id="start"></audio>

        <van-overlay :show="show" >
            <div class="wrapper" >
                <img class="blockimg" src="../images/active/rdy.png" v-show="isredy" >
                <img class="blockimg" src="../images/active/go.png" v-show="!isredy" >
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { Dialog } from "vant";
import { Overlay } from 'vant';
import Vue from "vue";
Vue.use(Overlay);
var light_timer; //灯光定时器
import Fetch from "../../utils/fetch";
import Api from "../../interface/index";

export default {
    name: "activity",
    data()
    {
        return {
            lang: this.$i18n.locale || "zh_cn",
            data: {},
            LuckyClick: 3,
            circleList: [], //原点设置
            colorCircleFirst: "#FE4D32", //圆点颜色
            colorCircleSecond: "#fff", //圆点颜色
            cat: 45, //总共8个扇形区域，每个区域约45度
            isAllowClick: true, //是否能够点击
            rotate_deg: 0, //指针旋转的角度
            rotate_transition: "transform 3s ease-in-out", //初始化选中的过度属性控制
            wheel_count: 0,
            wheel_list: [],
            last_angle: 0,
            balance: 0,
            bet_money: 1.00,
            win_money: "0.00",
            result_money: 0,
            good_list: [{img:null}],
            show:false,
            isredy:true,
            result_id:0,
        };
    },
    created()
    {

        this.$parent.footer('cart');
    },
    mounted()
    {
        this.init();
    },
    methods: {




        init()
        {
            Fetch("/UsEr/getUserInfoApi").then((r) =>
            {
                this.balance = r.data.money;
            });
            Fetch("/Our_Game/goodsList", { game_id: 120 }).then((r) =>
            {
                //console.log(r);
                this.good_list = r.data;
            });

        },
        go()
        {
            if (!this.isAllowClick)
            {
                return false;
            }
            if (this.balance < 1) return;
            if (this.balance < this.bet_money) return;
            this.balance = this.balance - this.bet_money;

            let start = document.getElementById('start');
            start.play();
            this.show = true;
            this.isredy = true;
            Fetch('/Our_Game/draw', { money: this.bet_money, game_id: 120 }, false, false).then(res =>
            {

                let num = -1;

                for (let i = 0; i < this.good_list.length; i++)
                {
                    if (res.data.good_id == this.good_list[i].id)
                    {
                        num = i;
                    }
                }
                
                console.log(num);//return;
                if (num != -1)
                {
                    this.isredy = false;
                    setTimeout(() => {
                        this.show = false;
                    }, 400);
                    this.rotating(num + 1, res.data.win_amount, res.data.balance);
                }
            })
        },
        rotating(id, win_amount, balance)
        {
            //console.log(this.isAllowClick);
            if (!this.isAllowClick)
            {
                return false;
            }
            this.isAllowClick = false;
            this.result_money = 0;
            //   var sec = Math.ceil(Math.random() * 10);
            var sec = 2;//转的时间
            var rand_circle = 6; //默认多旋转5圈
            this.rotate_transition = `transform ${sec + 1}s cubic-bezier(0.25,0.5,0.25,1)`;
            //console.log(this.rotate_transition);

            //   var winningIndex = Math.floor(Math.random() * 8); //获奖的下标   0-7   没有概率每个平均


            //console.log(winningIndex);
            var randomDeg = 360 - id * 45; //当前下标对应的角度    45是总共8个扇形区域，每个区域约45度
            // console.log(id);
            // return;
            let deg = 0;
            if (this.last_angle > 0)
            {
                //console.log(this.last_angle);
                let cha = this.last_angle % 360;
                //console.log("cha",cha);
                //return;
                //不是第一次转了
                deg = this.last_angle - cha + rand_circle * 360 + randomDeg + 22;
            } else
            {
                deg = rand_circle * 360 + randomDeg + 22;
            }
            this.last_angle = deg
            //将要旋转的度数  由于是顺时针的转动方向需要用360度来减

            //console.log(deg);
            this.rotate_deg = "rotate(" + deg + "deg)";

            var that = this;

            setTimeout(() =>
            {
                that.isAllowClick = true;
                that.win_money = win_amount;
                this.balance = balance;
                this.result_id = id - 1;
                this.result_money = win_amount;
                //this.rotate_deg = "rotate(" + (-45 * id + 22) + "deg)"; //定时器关闭的时候重置角度
                //that.rotate_transition = this.rotate_deg;
            }, sec * 1000 + 1000);
            return;
           
        },
        jian()
        {
            if (this.bet_money == 1) return;
            this.bet_money = this.bet_money - 1;
        },
        jia()
        {
            if (this.bet_money == 100) return;
            this.bet_money = this.bet_money + 1;
        },
        k2(num)
        {
            return Number(num).toFixed(2);
        }
    },
};
</script>

<style lang="less" scoped>
.hoho{
    display: flex;
    align-items: center;
    justify-content: center;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.blockimg {
  width: 150px;
//   height: 120px;
//   background-color: #fff;
}
.one-gf > img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
}
.one-gf{
    width: 24%;
    // height: 25px;
    // background: #1f51a6;
    padding: 5px;
    display: flex;
    // margin-bottom: 5px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;
    align-items: center;
    color:#fff; 
    overflow: hidden;
}
.gift-list{
    width: 98%;
    left: 2.5%;
    // height: 100px;
    // background: #ae5db6;
    position: fixed;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    top: 5px;
}
.jian {
    height: 50px;
    width: 50px;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    // background: purple;
    background: url("../images/active/-.png") 100% 100%;
    background-size: cover;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.go {
    height: 80px;
    width: 80px;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    background: url("../images/active/rotate.png") 100% 100%;
    background-size: cover;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 25px;
    margin-left: 30px;
}
.jia {
    height: 50px;
    width: 50px;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    // background: purple;
    background: url("../images/active/+.png") 100% 100%;
    background-size: cover;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.play-btns {
    color: white;
    // height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 10px 50px;
}
.yue {
    width: 22px;
    height: 18.5px;
    margin-left: 8px;
}
.mo1 > span {
    // width: 70%;
    // text-align: center;
    font-weight: 700;
    margin-left: 5px;
    color: rgb(242, 242, 24);
}
.mo1 {
    height: 30px;
    font-size: 10px;
    color: white;
    //background: linear-gradient(to right,rgb(166, 0, 146),rgb(89, 19, 214));
    background: #21702a;
    border-radius: 15px;
    // background: url('../images/active/crlcle.png') no-repeat 100%;
    // background-size: contain;
    width: 30%;
    display: flex;
    align-items: center;
    align-content: space-between;
}
.money-3 {
    color: white;
    display: flex;
    justify-content: space-around;
}
.res-money{
    margin-left: 5px;
}
.ani-img{
    width: 30px;
    margin-right: 5px;
    animation: iconAnimation 0.8s infinite; /* 应用动画，设置时长为0.4秒，无限循环 */
}
@keyframes iconAnimation {
  0%, 100% {
    transform: scale(1); /* 初始状态和结束状态都为原始大小 */
  }
  50% {
    transform: scale(0.7); /* 在动画的50%时，图标变成一半大小 */
  }
}
.tips {
    color: gold;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
}
.wheel-count {
    color: #f3cf3f;
}
.yline {
    height: 10px;
    background: url("../images/yline.png") no-repeat;
    background-size: 100% 100%;
    width: 90%;
    margin: 0 auto;
    border-radius: 2px;
}
.lottery-div {
    height: auto;
    width: 95%;
    margin: 0 auto;

    background: #1f51a6;
    box-shadow: 0px 0px 40px 0px rgba(255, 255, 255, 0.34);
    border-radius: 16px;
    padding: 15px;
}
.lottery-div p {
    height: 25px !important;
    line-height: 25px;
    color: white;
    text-align: left;
    font-family: ArialMT;
    font-size: 0.25rem;
}
.ac-title {
    height: 40px !important;
    line-height: 40px;
    width: 50%;
    margin: 0 auto;
    background: url("../images/ac-title.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    color: white;
    font-size: 0.4rem;
}

.rotate-wrap {
    width: 100%;
    height: 11.5rem;
    //background: red;
    position: relative;
}

.w-count {
    height: 40px;
    line-height: 40px;
    color: white;
    text-align: center;
    font-size: 0.5rem;
}

.bingo-details {
    //position: absolute;
    right: 10px;
    bottom: 70px;
    color: #e74848;
    font-weight: 700;
}

.bingo-details p {
    height: 20px;
}

.bingo-wrap {
    // background: rgba(0, 0, 0, 0.8);
    // background: url("../images/03.jpg") no-repeat;
    // background: url("../images/recharge/bg.png") no-repeat;
    // background-size: cover;
    // background-position: left 5px top -42px;
}

.red_top_bg {
    position: fixed;
    top: 0;
    z-index: 10;
}

.basic_wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2;
    background: #0e4114;
    //background: url("../images/recharge/bg.png") no-repeat!important;
    background-size: cover;
    // background-position: left 5px top -42px;
}

.big_tit {
    color: #000000;
}

.times {
    text-align: center;
    line-height: 0.8rem;
    background: #fff;
}

.rotate {
   
    background: #ffbe04;
    //border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    // bottom: top;
    top: 80px;
    left: 50%;
    width: 9rem;
    height: 9rem;
    margin-left: -4.5rem;
    //transform: translate(-50%, -50%);
    background: url("../images/01.png") no-repeat;
    background-size: 100% 100%;
}

.rotate .dish {
    // margin: 0 auto;
    width: 8rem;
    height: 8rem;
    margin-left: -0.19rem;
    margin-top:-0.18rem
    //border-radius: 50%;
}

.pointer {
    width: 1.5rem;
    height: 1.6rem;
    position: absolute;
    
    top: 46%;
    left: 48.7%;
    transform: translate(-50%, -50%);
}

/* 圆点 */
.rotate .circle {
    position: absolute;
    display: block;
    border-radius: 50%;
    height: 0.16rem;
    width: 0.16rem;
    background: black;
}

.rotate .circle_0 {
    top: 0.08rem;
    left: 2.92rem;
}

.rotate .circle_1 {
    top: 0.28rem;
    left: 4.05rem;
}

.rotate .circle_2 {
    top: 0.86rem;
    left: 4.95rem;
}

.rotate .circle_3 {
    top: 1.85rem;
    left: 5.65rem;
}

.rotate .circle_4 {
    top: 2.85rem;
    right: 0.1rem;
}

.rotate .circle_5 {
    bottom: 1.89rem;
    right: 0.29rem;
}

.rotate .circle_6 {
    bottom: 0.96rem;
    right: 0.88rem;
}

.rotate .circle_7 {
    bottom: 0.34rem;
    right: 1.76rem;
}

.rotate .circle_8 {
    bottom: 0.06rem;
    right: 3.06rem;
}

.rotate .circle_9 {
    bottom: 0.28rem;
    left: 1.9rem;
}

.rotate .circle_10 {
    bottom: 0.96rem;
    left: 0.88rem;
}

.rotate .circle_11 {
    bottom: 1.82rem;
    left: 0.28rem;
}

.rotate .circle_12 {
    top: 2.9rem;
    left: 0.1rem;
}

.rotate .circle_13 {
    top: 1.9rem;
    left: 0.28rem;
}

.rotate .circle_14 {
    top: 1rem;
    left: 0.86rem;
}

.rotate .circle_15 {
    top: 0.32rem;
    left: 1.76rem;
}
</style>
